import { Toaster } from 'sonner';

import { Success, Error, Notice } from './icons';

function AppToaster() {
    return (
        <Toaster
            position='bottom-center'
            swipeDirections={['left', 'right', 'bottom']}
            mobileOffset={{ bottom: 150 }}
            visibleToasts={1}
            icons={{
                error: <Error/>,
                success: <Success/>,
                info: <Notice/>,
            }}
            duration={2000}
            toastOptions={{
                unstyled: true,
                classNames: {
                    toast: 'toaster',
                },
            }}
        />
    );
}

export default AppToaster;
